<div #map class="google-map-container"></div>